import configData from '../data/config.json';
import type { GameConfigData } from './types';

export type GameConfig = GameConfigData;

export const GAME_CONFIG: Readonly<GameConfig> = configData;
